'use strict';

angular.module('dokiv')
  .filter('nl2br', ['$sanitize', function($sanitize) {
    return function (text) {
      return text ? $sanitize(text.replace(/\n/g, '<br>')) : '';
    };
  }]);



//////////////////
// WEBPACK FOOTER
// ./scripts/app/nl2brFilter.js
// module id = 265
// module chunks = 0